import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {OrderByPipe} from "./pipes/order-by.pipe";
import {TrustedMarkupPipe} from "./pipes/trusted-markup.pipe";
import {I18nPipe} from "./pipes/i18n.pipe";
import {UserDatePipe} from "./pipes/user-date.pipe";
import { InfiniteScrollComponent } from './components/infinite-scroll/infinite-scroll.component';
import { ContentPageHeaderComponent } from './components/content-page-header/content-page-header.component';
import { ContentPageFooterComponent } from './components/content-page-footer/content-page-footer.component';
import {ContextMenuAllModule, MenuAllModule} from "@syncfusion/ej2-angular-navigations";
import {DropDownButtonAllModule} from "@syncfusion/ej2-angular-splitbuttons";
import {ButtonAllModule} from "@syncfusion/ej2-angular-buttons";
import { GetValuePipe } from './pipes/get-value.pipe';
import { GetDisplayValuePipe } from './pipes/get-display-value.pipe';
import { GetFieldNamePipe} from "./pipes/get-field-name.pipe";
import {NthPipe} from "./pipes/nth.pipe";
import {StringifyPipe} from "./pipes/stringify.pipe";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    // DragDropModule,
    MenuAllModule,
    DropDownButtonAllModule,
    ContextMenuAllModule,
    ButtonAllModule,
  ],
  declarations: [
    OrderByPipe,
    TrustedMarkupPipe,
    I18nPipe,
    UserDatePipe,
    InfiniteScrollComponent,
    ContentPageHeaderComponent,
    ContentPageFooterComponent,
    GetValuePipe,
    GetDisplayValuePipe,
    GetFieldNamePipe,
    NthPipe,
    StringifyPipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollComponent,
    OrderByPipe,
    TrustedMarkupPipe,
    I18nPipe,
    UserDatePipe,
    ContentPageHeaderComponent,
    ContentPageFooterComponent,
    GetValuePipe,
    GetDisplayValuePipe,
    GetFieldNamePipe,
    NthPipe,
    StringifyPipe,
  ]
})
export class SharedModule { }
